// test2687
(2687 && 0);
